import React, { useState, useEffect } from 'react';
import './Connection.css';
import Alert from '../Alert/Alert';
import { useAuth } from '../Services/AuthContext';
import { useNavigate } from 'react-router-dom';

function Connection() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [isSmallScreen, setIsSmallScreen] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth < 700);
        };

        window.addEventListener('resize', handleResize);
        handleResize(); // Check initial screen size

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const validateInput = (input) => {
        const regex = /[`~<>;:"'/[\]|{}()=+]/;
        return !regex.test(input);
    };

    const handleLogin = () => {
        fetch('https://garagedufuniculaire.ch/funiculaire/src/Funiculaire/Backend/Connection.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ username, password }),
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                login();
                navigate('/panel'); 
            } else {
                setError(data.message);
                setShowAlert(true);
            }
        })
        .catch(error => {
            setError('Erreur de connexion.');
            setShowAlert(true);
        });
    };

    if (isSmallScreen) {
        return (
            <div className="message-small-screen">
                Veuillez agrandir votre fenêtre pour utiliser le panel administrateur.
            </div>
        );
    }

    return (
        <div className='background-connection'>
            {showAlert && (
                <Alert
                    message={error}
                    type="error"
                    onClose={() => setShowAlert(false)}
                />
            )}
            <div className='container-connection'>
                <h1>Connexion</h1>
                <p>Veuillez remplir les champs ci-dessous.</p>
                <div className='input-box'>
                    <label htmlFor="username">Nom d'utilisateur</label>
                    <input
                        type="text"
                        name="username"
                        id="username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                </div>
                <div className='input-box'>
                    <label htmlFor="password">Mot de passe</label>
                    <input
                        type="password"
                        name="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </div>
                <div className='container-btn'>
                    <button onClick={handleLogin}>Connexion</button>
                </div>
            </div>
        </div>
    );
}

export default Connection;
